import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(d);
}

export function formatDateTime(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
}

export const PHASE_COLORS = ['#EFE9DC', '#E2DACA', '#F7E08A', '#F4D03F', '#E2B520', '#5E5A52', '#161512'];

/** Phase 1..7 -> design token color */
export function getPhaseColor(phase: number): string {
  return PHASE_COLORS[Math.min(Math.max(phase, 1), 7) - 1];
}

/** Phase group: Neu = 1-2, In Arbeit = 3-5, Gelernt = 6-7 */
export function phaseGroup(phase: number): 'neu' | 'arbeit' | 'gelernt' {
  return phase <= 2 ? 'neu' : phase <= 5 ? 'arbeit' : 'gelernt';
}
